import { Button } from 'antd'
import { PrinterOutlined } from '@ant-design/icons'
import { pdf } from '@react-pdf/renderer'
import * as FileSaver from 'file-saver'
import { satisfaccion_catalog } from "../../../../escalas/satisfaccion/satisfaccion_catalog"
import { satisfaccion_2_catalog } from "../../../../escalas/satisfaccion_2/satisfaccion_2.catalog"
import SatisfaccionPDF from '../../printed-docs/printed-scales/satisfaccion-pdf'

export default function SatisfaccionResults({ satisfaccion, pacienteData, fecha }) {
    const respuestas_radio = ["Completamente en desacuerdo", "En desacuerdo", "Neutral", "De acuerdo", "Totalmente de acuerdo"]
    const respuestas_seleccion = ["No", "Si"]

    const getRespuesta = (item, resp) => {
        if (item.tipo === 'radioButton') {
            return respuestas_radio[resp]
        }
        if (item.tipo === 'seleccion') {
            return resp
        }
        if (item.tipo === 'texto') {
            return resp
        }
    }

    const handlePrint = async () => {
        const blob = await pdf(<SatisfaccionPDF pacienteData={pacienteData} fecha={fecha} satisfaccion={satisfaccion} />).toBlob()
        FileSaver.saveAs(blob, `satisfaccion_${pacienteData?.name || 'paciente'}.pdf`)
    }

    return (
        <div>
            {/* {JSON.stringify(satisfaccion)} */}
            {
                satisfaccion_2_catalog.map((item, index) => (
                    <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{item["label"]}</td>
                        {/* <td>{satisfaccion[index]}</td> */}
                        <td>{getRespuesta(item, satisfaccion[index])}</td>
                    </tr>
                ))
            }
            <div style={{ marginTop: 10, textAlign: 'right' }}>
                <Button icon={<PrinterOutlined />} onClick={handlePrint}>Imprimir escala en pdf</Button>
            </div>
        </div>
    )
}